export default "__VITE_ASSET__BnqlrMBw__"